import React, { useState, useEffect } from 'react';
import { login } from '../services/api';

export default function Login({ onLogin, configuracao }) {
    const nomePlataforma = configuracao?.nome_plataforma || 'Sigatron';
    const logo = configuracao?.logo_base64;
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [lembrar, setLembrar] = useState(false);
    const [erro, setErro] = useState('');
    const [carregando, setCarregando] = useState(false);

    useEffect(() => {
        const emailSalvo = localStorage.getItem('lembrar_email');
        if (emailSalvo) {
            setEmail(emailSalvo);
            setLembrar(true);
        }
    }, []);

    const entrar = async (e) => {
        e.preventDefault();
        setErro('');
        setCarregando(true);
        try {
            const res = await login(email, senha, lembrar);
            if (lembrar) {
                localStorage.setItem('lembrar_email', email);
            } else {
                localStorage.removeItem('lembrar_email');
            }
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('usuario', JSON.stringify(res.data.usuario));
            onLogin(res.data.usuario);
        } catch(err) {
            setErro(err.response?.data?.erro || 'Erro ao conectar');
        } finally {
            setCarregando(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: '#f2f2f7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif',
        }}>
            <div style={{ width: 340, maxWidth: '92vw' }}>

                {/* Logo / título */}
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    {/* Logo customizado, ou ícone minimalista padrão */}
                    <div style={{
                        width: logo ? 104 : 64, height: logo ? 104 : 64, borderRadius: logo ? 24 : 16,
                        background: logo ? 'white' : 'linear-gradient(145deg, #1c1c1e, #2c2c2e)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 16px', overflow: 'hidden', boxSizing: 'border-box',
                        padding: logo ? 16 : 0,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.18)',
                    }}>
                        {logo ? (
                            <img src={logo} alt={nomePlataforma} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                        ) : (
                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="10" r="4" fill="white" opacity="0.95"/>
                                <path d="M12 2C7.58 2 4 5.58 4 10c0 5.25 8 13 8 13s8-7.75 8-13c0-4.42-3.58-8-8-8z"
                                    fill="white" opacity="0.3"/>
                                <circle cx="12" cy="10" r="2" fill="#1c1c1e"/>
                            </svg>
                        )}
                    </div>
                    <h1 style={{ margin: 0, fontSize: 24, color: '#1c1c1e', fontWeight: 700, letterSpacing: -0.5, whiteSpace: 'nowrap' }}>
                        {nomePlataforma}
                    </h1>
                    <p style={{ margin: '5px 0 0', color: '#8e8e93', fontSize: 13, fontWeight: 400 }}>
                        Rastreamento Veicular
                    </p>
                </div>

                {/* Card do formulário */}
                <div style={{
                    background: 'white',
                    borderRadius: 16,
                    overflow: 'hidden',
                    boxShadow: '0 2px 20px rgba(0,0,0,0.08)',
                }}>
                    <form onSubmit={entrar}>
                        {/* Campo email */}
                        <div style={{ borderBottom: '1px solid #e5e5ea', padding: '4px 16px' }}>
                            <label style={{ fontSize: 11, color: '#8e8e93', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 10 }}>
                                Email
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="seu@email.com"
                                required
                                autoComplete="email"
                                style={{
                                    width: '100%', padding: '8px 0 10px', border: 'none',
                                    fontSize: 16, color: '#1c1c1e', outline: 'none',
                                    background: 'transparent', boxSizing: 'border-box',
                                }}
                            />
                        </div>

                        {/* Campo senha */}
                        <div style={{ padding: '4px 16px' }}>
                            <label style={{ fontSize: 11, color: '#8e8e93', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 10 }}>
                                Senha
                            </label>
                            <input
                                type="password"
                                value={senha}
                                onChange={e => setSenha(e.target.value)}
                                placeholder="••••••••"
                                required
                                autoComplete="current-password"
                                style={{
                                    width: '100%', padding: '8px 0 10px', border: 'none',
                                    fontSize: 16, color: '#1c1c1e', outline: 'none',
                                    background: 'transparent', boxSizing: 'border-box',
                                }}
                            />
                        </div>
                    </form>
                </div>

                {/* Lembrar email */}
                <div
                    onClick={() => setLembrar(l => !l)}
                    style={{
                        display: 'flex', alignItems: 'center', gap: 10,
                        padding: '14px 4px', cursor: 'pointer', userSelect: 'none',
                    }}
                >
                    <div style={{
                        width: 22, height: 22, borderRadius: 6,
                        background: lembrar ? '#007aff' : 'white',
                        border: lembrar ? 'none' : '1.5px solid #c7c7cc',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        transition: 'all 0.18s', flexShrink: 0,
                        boxShadow: lembrar ? '0 2px 8px rgba(0,122,255,0.35)' : 'none',
                    }}>
                        {lembrar && (
                            <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                                <path d="M1 5l3.5 3.5L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        )}
                    </div>
                    <span style={{ fontSize: 14, color: '#3a3a3c' }}>Permanecer conectado</span>
                </div>

                {/* Erro */}
                {erro && (
                    <div style={{
                        background: '#fff2f2', borderRadius: 10, padding: '11px 14px',
                        marginBottom: 12, color: '#c0392b', fontSize: 13,
                        border: '1px solid #ffd0d0',
                    }}>{erro}</div>
                )}

                {/* Botão entrar */}
                <button
                    onClick={entrar}
                    disabled={carregando}
                    style={{
                        width: '100%', padding: '14px', borderRadius: 14, border: 'none',
                        background: carregando ? '#aeaeb2' : '#007aff',
                        color: 'white', fontSize: 16, fontWeight: 600,
                        cursor: carregando ? 'not-allowed' : 'pointer',
                        letterSpacing: 0.2,
                        boxShadow: carregando ? 'none' : '0 4px 16px rgba(0,122,255,0.35)',
                        transition: 'all 0.2s',
                    }}
                >
                    {carregando ? 'Entrando...' : 'Entrar'}
                </button>

                <p style={{ textAlign: 'center', marginTop: 28, fontSize: 12, color: '#aeaeb2' }}>
                    Sigatron LTDA © {new Date().getFullYear()}
                </p>
            </div>
        </div>
    );
}
